import IconImportDownload from "@synthesis/shared-icons/IconImportDownload";
import { Button } from "@synthesis/shared-ui";

import { useClientType } from "../../shared/hooks/use-client-type";
import { useUserRoles } from "../../shared/hooks/use-user-roles";

export type ImportApplicationButtonProps = {
  onOpen: () => void;
  className?: string;
  disabled?: boolean;
};

export const ImportApplicationButton = ({ onOpen, className, disabled }: ImportApplicationButtonProps) => {
  const clientType = useClientType();
  const userRoles = useUserRoles();

  const isOperator = (clientType === "external" && userRoles.isExternalOperator) || (clientType === "internal" && userRoles.isInternalOperator);

  if (!isOperator) {
    return null;
  }

  return (
    <Button
      type="button"
      theme="secondary"
      size="sm"
      leftIcon={<IconImportDownload className="size-5" />}
      className={className}
      disabled={disabled}
      onClick={onOpen}
    >
      Импортировать
    </Button>
  );
};
